<div
	class="card cursor-pointer hover-target hover-bg-translucent-blue listing-card"
	tabindex="0"
	(keydown.space)="navigateListing($event)"
>
	<div class="row gx-0">
		<div class="col-lg-5 position-relative">
			<img
				class="card-img hover-opacity-50"
				[src]="
					(listing.mediaFileName
						| listingMediaUrl
							: 'thumb'
							: listing.modificationTimestampUTCDTTM
							: errorLoadingImage) || 'assets/images/svg/Img-Default-Camera.svg'
				"
				(error)="errorLoadingImage = true"
			/>
			<div class="card-img-overlay d-flex flex-column justify-content-between p-0">
				<ng-container *ngIf="showExpiresBanner">
					<span
						class="opacity-66 rounded-top bg-danger text-white small fw-bold py-1 px-3"
						*ngIf="showExpiringIn && expiresIn > 0"
						>Expires in {{ expiresIn }} day(s)</span
					>
					<span
						class="opacity-66 rounded-top bg-danger text-white small fw-bold py-1 px-3"
						*ngIf="showExpiredOn"
						>Expired on {{ listing.expirationDT | date : "shortDate" }}</span
					>
					<span
						class="opacity-66 rounded-top bg-danger text-white small fw-bold py-1 px-3"
						*ngIf="showExpiringIn && listing.listingStatusCD === 'I' && expiresIn === 0"
						>Deletes today!</span
					>
					<span
						class="opacity-66 rounded-top bg-danger text-white small fw-bold py-1 px-3"
						*ngIf="showExpiringIn && listing.listingStatusCD !== 'I' && expiresIn === 0"
						>Expires today!</span
					>
				</ng-container>
				<span class="expire none" *ngIf="!showExpiresBanner"></span>
				<div
					class="d-flex flex-row justify-content-between opacity-75 rounded-bottom bg-secondary text-white fw-bold small py-1 px-3"
				>
					<span>
						{{ listing.listingStatusName }}
					</span>
					<span
						*ngIf="hasContingency"
						[ngbTooltip]="listing.contingencyTypeCD | translate : { type: 'contingency' }"
						container="body"
					>
						Contingency
					</span>
				</div>
			</div>
		</div>
		<div class="col-lg-7 d-flex flex-column text-muted hover-text-light">
			<div class="card-header bg-transparent d-flex justify-content-end ps-1 py-2 border-0">
				<span class="col-auto ps-3 pe-2">
					<img
						[ngbTooltip]="listing.propertyTypeCD | translate"
						container="body"
						[src]="listing.propertyTypeCD | translate : { type: 'icon' }"
						style="height: 27px"
						class="hover-brightness-2"
					/>
				</span>
				<p class="col text-primary hover-text-white m-0 p-0">{{ listing.listingID }}</p>
				<button
					nstarButton
					class="btn p-0 m-0 ms-2 text-muted hover-text-light recover-btn"
					ngbTooltip="Recover"
					*ngIf="canRecover$ | async"
					(click)="recoverListing($event)"
				>
					<i nstarIcon>recover</i>
				</button>
				<button
					nstarButton
					class="btn p-0 m-0 ms-2 text-muted hover-text-light clone-btn"
					ngbTooltip="Clone"
					*ngIf="canClone$ | async"
					(click)="cloneListing($event)"
				>
					<i nstarIcon>clone</i>
				</button>
				<button
					nstarButton
					class="btn p-0 m-0 ms-2 text-muted hover-text-light copy-btn"
					ngbTooltip="Copy"
					*ngIf="canCopy$ | async"
					(click)="copyListing($event)"
				>
					<i nstarIcon>copy</i>
				</button>
				<button
					nstarButton
					class="btn p-0 m-0 ms-2 text-muted hover-text-light delete-btn"
					ngbTooltip="Delete"
					*ngIf="canDelete$ | async"
					(click)="deleteListing($event)"
				>
					<i nstarIcon>delete</i>
				</button>
			</div>
			<div class="card-body py-0">
				<div class="d-flex justify-content-between px-3">
					<p class="date small">
						<span *ngIf="!!listing.listingContractDT"
							>List Date: {{ listing.listingContractDT | date : "shortDate" }}</span
						>
					</p>
					<p
						class="small"
						*ngIf="listing.propertyTypeCD === 'FRM' || listing.propertyTypeCD === 'LL'"
					>
						<span *ngIf="!!listing.acres">Acres: {{ listing.acres }}</span>
					</p>
				</div>
				<div class="row px-3 small font-italic">
					<p class="w-100 d-flex flex-column">
						<span *ngIf="!!listing.unparsedAddress">{{ listing.unparsedAddress }}</span>
						<span
							*ngIf="
								!!(displayLocationName$ | async) ||
								!!listing.stateOrProvinceCD ||
								!!listing.postalCode
							"
						>
							<span
								*ngIf="displayLocationName$ | async as displayLocationName"
								[ngbTooltip]="tooltipLocationName$ | async"
								>{{ displayLocationName }},
							</span>
							{{ listing.stateOrProvinceCD }} {{ listing.postalCode }}
						</span>
					</p>
				</div>
			</div>
			<div class="card-footer bg-transparent d-flex justify-content-between border-0 py-1 small">
				<span
					><span class="badge bg-primary text-light" [ngbTooltip]="tooltipName$ | async"
						><i nstarIcon>agent</i> {{ displayName$ | async }}</span
					></span
				>
				<span class="price">{{ price | currency : "USD" : "symbol" : "0.0-2" }}</span>
			</div>
		</div>
		<div class="preview-holder d-flex" *ngIf="hasPreviewPermissions">
			<ng-container *ngIf="listing.adbuilderLoaded; else placeholderTemplate">
				<button
					*ngIf="showPreviewAd && !listing?.adbuilderCampaign"
					(click)="previewAd($event)"
					class="btn btn-sm w-100 btn-light text-primary preview-btn"
				>
					<span class="bullhorn-icon"></span>
					{{ adbuilderButtonTitle }}
				</button>
				<button
					*ngIf="hasPreviewPermissions && !showPreviewAd"
					(click)="navigateListing($event)"
					[disabled]="listing.canNavigate === false"
					class="btn btn-sm w-100 btn-light text-primary preview-btn"
				>
					{{ listing.canNavigate ? "Navigate to Listing" : "Listing Deleted" }}
				</button>
				<span
					class="manage-campaign d-flex w-100"
					*ngIf="showPreviewAd && listing?.adbuilderCampaign"
					(click)="previewAd($event)"
				>
					<button class="btn btn-sm btn-light text-primary preview-btn col-sm-6 col-lg-8">
						<span class="bullhorn-icon"></span>
						Manage Campaign
					</button>
					<table class="campaign-table text-muted hover-text-light col-sm-6 col-lg-4">
						<thead>
							<tr>
								<th>Views</th>
								<th>Clicks</th>
								<th>Leads</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ listing?.adbuilderCampaign?.Impressions | number }}</td>
								<td>{{ listing?.adbuilderCampaign?.Clicks | number }}</td>
								<td>{{ listing?.adbuilderCampaign?.Leads | number }}</td>
							</tr>
						</tbody>
					</table>
				</span>
			</ng-container>
		</div>
		<ng-template #placeholderTemplate>
			<span class="placeholder-glow w-100">
				<a
					href="#"
					tabindex="-1"
					class="btn btn-dark disabled placeholder col-12"
					aria-hidden="true"
				></a>
			</span>
		</ng-template>
	</div>
</div>
